import LoginByTel from './LoginByTel';

export default LoginByTel;